import { Link } from "react-router-dom";
import { scrollToId } from "@/components/Navbar";
import { COMPANY } from "@/data/content";
import { Separator } from "@/components/ui/separator";

const FOOTER_SERVICES = [
  "Website & App Development",
  "E-Commerce & Shopify",
  "Amazon · eBay · Etsy",
  "Cyber Security",
  "Servers & Databases",
  "Office & Adobe Licences",
];

const FOOTER_LINKS = [
  { label: "Services", id: "services" },
  { label: "Commerce", id: "commerce" },
  { label: "Work", id: "work" },
  { label: "About", id: "about" },
  { label: "FAQ", id: "faq" },
  { label: "Contact", id: "contact" },
];

export const Footer = () => {
  return (
    <footer className="noise-overlay bg-background border-t border-border" data-testid="main-footer">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2 max-w-sm">
            <div className="flex items-center gap-3">
              <img src="/fcy-mark.png" alt="FCY IT Consultancy logo" className="w-9 h-9 object-contain" />
              <span className="text-sm font-semibold tracking-wide text-foreground">
                FCY IT CONSULTANCY LTD
              </span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-muted-foreground">
              An elite London IT consultancy delivering websites, mobile apps, e-commerce
              growth, secure infrastructure and custom business systems — led personally by
              director {COMPANY.director}.
            </p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-widest text-muted-foreground mb-4">
              Explore
            </h4>
            <ul className="space-y-2.5">
              {FOOTER_LINKS.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToId(link.id)}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200"
                    data-testid={`footer-${link.id}-link`}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-widest text-muted-foreground mb-4">
              Services
            </h4>
            <ul className="space-y-2.5">
              {FOOTER_SERVICES.map((service) => (
                <li key={service} className="text-sm text-muted-foreground">
                  {service}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <Separator className="my-9 bg-border" />

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-xs text-muted-foreground">
          <div>
            <p className="uppercase tracking-wider text-muted-foreground/70 mb-1">Registered Office</p>
            <p>{COMPANY.address}</p>
          </div>
          <div>
            <p className="uppercase tracking-wider text-muted-foreground/70 mb-1">Contact</p>
            <p>{COMPANY.phone}</p>
            <p>
              {COMPANY.email} · {COMPANY.email2}
            </p>
          </div>
          <div>
            <p className="uppercase tracking-wider text-muted-foreground/70 mb-1">SIC Codes</p>
            <p className="font-mono-meta">
              {COMPANY.sic.map((s) => s.code).join(" · ")}
            </p>
          </div>
        </div>

        <div className="mt-9 pt-6 border-t border-border flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} {COMPANY.name} · Company No.{" "}
            <span className="font-mono-meta">{COMPANY.number}</span> · Registered in England &
            Wales
          </p>
          <Link
            to="/admin"
            className="text-xs text-muted-foreground/50 hover:text-muted-foreground transition-colors duration-200"
            data-testid="footer-admin-link"
          >
            Owner Access
          </Link>
        </div>
      </div>
    </footer>
  );
};
